import { render } from "./MainHeaderBannerComponent.vue?vue&type=template&id=7a5b5283&scoped=true"
import script from "./MainHeaderBannerComponent.vue?vue&type=script&lang=js"
export * from "./MainHeaderBannerComponent.vue?vue&type=script&lang=js"

import "./MainHeaderBannerComponent.vue?vue&type=style&index=0&id=7a5b5283&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a5b5283"]])

export default __exports__